// font-size-adjuster.directive.ts
import { Directive, ElementRef, HostListener, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appFontSizeAdjuster]'
})
export class FontSizeAdjusterDirective implements AfterViewInit {
  private originalFontSize: number;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.originalFontSize=10;
  }

  ngAfterViewInit() {
    this.originalFontSize = parseFloat(window.getComputedStyle(this.el.nativeElement).fontSize);
    this.adjustFontSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.adjustFontSize();
  }

  @HostListener('window:beforeprint')
  beforePrint() {
    this.adjustFontSize();
  }

  private adjustFontSize() {
    const element = this.el.nativeElement;
    const parentWidth = element.parentElement.offsetWidth;

    this.renderer.setStyle(element, 'white-space', 'nowrap');
    let fontSize = this.originalFontSize;

    while (element.scrollWidth > parentWidth && fontSize > 0) {
      fontSize -= 1;
      this.renderer.setStyle(element, 'font-size', `${fontSize}px`);
    }

    // this.renderer.setStyle(element, 'white-space', 'normal');
  }
}
